import React from 'react';
import { Badge } from 'react-bootstrap';

const gradeConfig = {
  A: { bg: 'success', label: 'A' },
  B: { bg: 'primary', label: 'B' },
  C: { bg: 'warning', label: 'C', text: 'dark' },
  D: { bg: 'danger',  label: 'D' }
};

const QscGradeBadge = ({ grade }) => {
  const config = gradeConfig[grade] || { bg: 'secondary', label: grade || '-' };
  return (
    <Badge bg={config.bg} text={config.text}>
      เกรด {config.label}
    </Badge>
  );
};

export default QscGradeBadge;
